// extracted by css-extract-rspack-plugin
export default {"disc":"S9maie"};